import OuigoSlowTrain from 'common/assets/images/ouigo-slow-train.svg';
import OuigoLbTrain from 'common/assets/images/ouigo_lb_magritte_train.svg';
import OuigoFRTrain from 'common/assets/images/ouigo-fr-train.svg';
import OuigoESTrain from 'common/assets/images/ouigo-es-train.svg';

export const getCarriageBackgroundImage = (selectedServiceType: string) => {
  let carriageImage = '';
  switch (selectedServiceType) {
    case 'OUIGO_ESP':
      carriageImage = OuigoESTrain;
      break;
    case 'OUIGO_LC':
      carriageImage = OuigoSlowTrain;
      break;
    case 'OUIGO_LB':
      carriageImage = OuigoLbTrain;
      break;
    case 'OUIGO':
    default:
      carriageImage = OuigoFRTrain;
      break;
  }
  return carriageImage;
};
